/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { c as customParseFormat } from '../_chunks/dep-fdce1f4f.js';
import { TimeIcon } from 'tdesign-icons-react';
import forwardRefWithStatics from '../_util/forwardRefWithStatics.js';
import useControlled from '../hooks/useControlled.js';
import useConfig from '../hooks/useConfig.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import noop from '../_util/noop.js';
import { SelectInput } from '../select-input/index.js';
import TimeRangePicker from './TimeRangePicker.js';
import TimePickerPanel from './panel/TimePickerPanel.js';
import { useTimePickerTextConfig } from './hooks/useTimePickerTextConfig.js';
import { validateInputValue, formatInputValue } from '../_common/js/time-picker/utils.js';
import { DEFAULT_FORMAT, DEFAULT_STEPS } from '../_common/js/time-picker/const.js';
import { timePickerDefaultProps } from './defaultProps.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-77a54538.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-7dce2c26.js';
import 'hoist-non-react-statics';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-77e34309.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../select-input/SelectInput.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../_util/useAnimation.js';
import '../hooks/usePrevious.js';
import '../common/Portal.js';
import 'react-dom';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../select-input/useSingle.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-e73d1b75.js';
import '../_chunks/dep-c8399d32.js';
import '../input/index.js';
import '../input/Input.js';
import '../_chunks/dep-92728dc5.js';
import '../_util/useLayoutEffect.js';
import '../input/InputGroup.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../input/style/css.js';
import '../input/type.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/TagInput.js';
import '../_util/useDragSorter.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/defaultProps.js';
import '../select-input/style/css.js';
import '../select-input/type.js';
import '../range-input/index.js';
import '../range-input/RangeInput.js';
import '../range-input/defaultProps.js';
import '../range-input/RangeInputPopup.js';
import '../range-input/style/css.js';
import '../range-input/type.js';
import './panel/SinglePanel.js';
import '../hooks/useDebounce.js';
import '../_util/usePersistFn.js';
import '../hooks/usePropsRef.js';
import '../button/index.js';
import '../button/Button.js';
import '../_util/useRipple.js';
import '../_util/setStyle.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
dayjs.extend(customParseFormat);
var TimePicker = forwardRefWithStatics(function (props, ref) {
  var TEXT_CONFIG = useTimePickerTextConfig();
  var allowInput = props.allowInput,
    className = props.className,
    clearable = props.clearable,
    disabled = props.disabled,
    style = props.style,
    _props$format = props.format,
    format = _props$format === void 0 ? DEFAULT_FORMAT : _props$format,
    _props$hideDisabledTi = props.hideDisabledTime,
    hideDisabledTime = _props$hideDisabledTi === void 0 ? true : _props$hideDisabledTi,
    _props$steps = props.steps,
    steps = _props$steps === void 0 ? DEFAULT_STEPS : _props$steps,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? TEXT_CONFIG.placeholder : _props$placeholder,
    disableTime = props.disableTime,
    _props$onBlur = props.onBlur,
    onBlur = _props$onBlur === void 0 ? noop : _props$onBlur,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? noop : _props$onClose,
    _props$onFocus = props.onFocus,
    onFocus = _props$onFocus === void 0 ? noop : _props$onFocus,
    _props$onOpen = props.onOpen,
    onOpen = _props$onOpen === void 0 ? noop : _props$onOpen,
    _props$onInput = props.onInput,
    onInput = _props$onInput === void 0 ? noop : _props$onInput;
  var _useControlled = useControlled(props, "value", props.onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    onChange = _useControlled2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPanelShowed = _useState2[0],
    setPanelShow = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    currentValue = _useState4[0],
    setCurrentValue = _useState4[1];
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useGlobalIcon = useGlobalIcon({
      TimeIcon: TimeIcon
    }),
    TimeIcon$1 = _useGlobalIcon.TimeIcon;
  var name = "".concat(classPrefix, "-time-picker");
  var inputClasses = classNames("".concat(name, "__group"), _defineProperty({}, "".concat(classPrefix, "-is-focused"), isPanelShowed));
  var handleShowPopup = function handleShowPopup(visible, context) {
    setPanelShow(visible);
    visible ? onOpen(context) : onClose(context);
  };
  var handleClear = function handleClear(context) {
    var e = context.e;
    e.stopPropagation();
    setCurrentValue("");
    onChange(null);
  };
  var handleInputChange = function handleInputChange(value2, context) {
    setCurrentValue(value2);
    if (allowInput) {
      onInput({
        value: value2,
        e: context.e
      });
    }
  };
  var handleInputBlur = function handleInputBlur(value2, ctx) {
    if (allowInput) {
      var isValidTime = validateInputValue(currentValue, format);
      if (isValidTime) {
        onChange(formatInputValue(currentValue, format));
      }
    }
    onBlur(_objectSpread({
      value: String(value2)
    }, ctx));
  };
  var handleClickConfirm = function handleClickConfirm() {
    var isValidTime = validateInputValue(currentValue, format);
    if (isValidTime) onChange(currentValue);
    setPanelShow(false);
  };
  useEffect(function () {
    setCurrentValue(isPanelShowed ? value !== null && value !== void 0 ? value : "" : "");
  }, [isPanelShowed, value]);
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(name, className),
    ref: ref,
    style: style
  }, /* @__PURE__ */React.createElement(SelectInput, {
    onFocus: onFocus,
    onClear: handleClear,
    disabled: disabled,
    clearable: clearable,
    allowInput: allowInput,
    className: inputClasses,
    suffixIcon: /* @__PURE__ */React.createElement(TimeIcon$1, null),
    popupVisible: isPanelShowed,
    onInputChange: handleInputChange,
    onBlur: handleInputBlur,
    onPopupVisibleChange: handleShowPopup,
    placeholder: !value ? placeholder : void 0,
    value: isPanelShowed ? currentValue : value !== null && value !== void 0 ? value : void 0,
    inputValue: isPanelShowed ? currentValue : value !== null && value !== void 0 ? value : void 0,
    inputProps: props.inputProps,
    popupProps: _objectSpread({
      overlayInnerStyle: {
        width: "auto",
        padding: 0
      }
    }, props.popupProps),
    tips: props.tips,
    status: props.status,
    panel: /* @__PURE__ */React.createElement(TimePickerPanel, {
      steps: steps,
      format: format,
      value: currentValue,
      isFooterDisplay: true,
      isShowPanel: isPanelShowed,
      disableTime: disableTime,
      onChange: setCurrentValue,
      onPick: props.onPick,
      hideDisabledTime: hideDisabledTime,
      handleConfirmClick: handleClickConfirm
    })
  }));
}, {
  TimeRangePicker: TimeRangePicker,
  TimePickerPanel: TimePickerPanel
});
TimePicker.displayName = "TimePicker";
TimePicker.defaultProps = timePickerDefaultProps;

export { TimePicker as default };
//# sourceMappingURL=TimePicker.js.map
